import React from "react";
import { ProjectStyle } from "./style";
import img1 from './icons/laundry.png';
import img2 from './icons/iron-.png';
import img3 from './icons/payment.png';

export default function Projects() {
  return (
    <ProjectStyle id="services">
      <div>
        <ul>
          <li>
            <img src={img1} alt="icone lavanderia"/>
            <h4>Lavagens com perfeição</h4>
            <p>Lavamos sua roupa de acordo com suas especificações, respeitando cada tipo de material. Lavagens feitas com carinho, dedicação e maestria! </p>
          </li>

          
          <li>
            <img src={img2} alt=""/>
            <h4>Passamos</h4>
            <p>Após a lavagem, que tal já levar ou receber suas roupas passadas? Também contamos com esse serviço em nossa lavanderia, agilize seu tempo e conte conosco para essa missão.</p>
          </li>

          
          <li>
            <img src={img3} alt=""/>
            <h4>Pagamentos facilitados</h4>
            <p>Pagamentos fáceis para todos os tipos de clientes, para mais informações dos tipos de pagamentos que aceitamos, clique <a href="#faq">aqui</a>.</p>
          </li>
        </ul>
      </div>
    </ProjectStyle>
  );
}
